import { LogicNodeDefinition } from '../LogicNodeDefinition';

export const TrueNode: LogicNodeDefinition = {
  type: 'TRUE',
  createDefaultState: () => null,
  process: () => true,
};
